<template>
  <el-dialog
    v-bind="$attrs"
    title="Сортировка"
    :width="popupWidth"
    :visible="is_visible"
    :close-on-click-modal="false"
    @close="closeDialog"
    class="dialog"
  >
    <div v-loading="loading" class="dialog__inner">
      <div class="filter-frame__items">
        <el-form
          id="filter-form"
          v-if="filters"
          :model="form"
          size="mini"
          hide-required-asterisk
        >
          <el-form-item
            v-for="filterKey in Object.keys(filters)"
            :key="filters[filterKey].name"
            :prop="filters[filterKey].name"
            class="filter"
          >
            <p>{{ filters[filterKey].lbl }}</p>
            <Dropdown
              :model="form[filters[filterKey].name]"
              :options="filters[filterKey].options"
              filterable
              :field="{
                name: filters[filterKey].name,
                placeholder: '',
                type: 'enum'
              }"
              :arrow-multiselect-focus="true"
              popper-class="filter-dropdown"
              class="filter-form__filter"
              @set-value="
                (name, val) => {
                  $set(form, filters[filterKey].name, val);
                }
              "
            />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div slot="footer">
      <div class="footer footer--auto-width">
        <Button
          v-for="button in buttons"
          :key="button.lbl.name"
          :buttonSize="button.sizeVisualClass"
          :buttonColor="button.colorVisualClass"
          :buttonText="button.lbl.value"
          :disabled="button.type === 'cancelButton' && noChanges"
          @click="btnAction(button)"
          class="footer__button-cancel"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { store } from '@/store';
import { MODULE, DIALOG_WIDTH } from '@/utils/constants';
import { Dialog, Form, FormItem } from 'element-ui';
import Button from 'Elements/Button/Button';
import Dropdown from 'Elements/Select/Dropdown';

export default {
  props: {
    is_visible: {
      type: Boolean
    },
    moduleName: {
      type: String,
      default: MODULE.CANDIDATES_MODULE
    },
    mode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      form: {},
      originalSort: {}
    };
  },
  async created() {
    this.loading = true;

    await store.dispatch('filters/getSortData', store.state.filters.intents);

    this.loading = false;

    for (const filterKey in this.filters) {
      this.$set(
        this.form,
        this.filters[filterKey].name,
        this.currentPageSortCashValues &&
          this.currentPageSortCashValues.hasOwnProperty(
            this.filters[filterKey].name
          )
          ? this.currentPageSortCashValues[this.filters[filterKey].name]
          : this.filters[filterKey].value
      );

      if (this.filters[filterKey].name === 'sort_popup_sort') {
        let sortDefaultValue = Object.keys(
          this.filters[filterKey].options
        ).find(
          el =>
            el === 'DATE_ENTERED' || el === 'COORDINATION_TERM' || el === 'NAME'
        );
        this.$set(
          this.originalSort,
          'sort_popup_sort',
          sortDefaultValue
            ? sortDefaultValue
            : this.filters[filterKey].options[0]
        );
      } else if (this.filters[filterKey].name === 'sort_popup_value') {
        let sortDefaultValue = Object.keys(
          this.filters[filterKey].options
        ).find(el => el === 'DESC');
        this.$set(
          this.originalSort,
          'sort_popup_value',
          sortDefaultValue
            ? sortDefaultValue
            : this.filters[filterKey].options[0]
        );
      }
    }
  },
  methods: {
    async btnAction(button) {
      store.commit('filters/setSortActive', !this.noChanges);

      if (button.type === 'searchButton') {
        this.applyFilters(button.intents[1].request);
      }
      if (button.type === 'cancelButton') {
        this.clearFilter();
      }
    },
    closeDialog() {
      store.commit('filters/setIntents', {});
      store.commit('filters/setParam', { name: 'sortPopupMetaData', val: {} });
      store.commit('common/setVisibleDialog', {
        name: 'sort_dialog',
        val: false
      });
    },
    clearFilter() {
      Object.keys(this.originalSort).forEach(key => {
        this.$set(this.form, key, this.originalSort[key]);
      });
    },
    async applyFilters(request) {
      let massAttachment =
        this.buttons[1].intents[1].request.request_params?.selected_ids?.length;
      // if (massAttachment) {
      //   const link = localStorage.getItem('AttachmentLink');
      //   const isASCSortMethod = link.includes('ASC');
      //   let newLink = '';
      //   if (isASCSortMethod && this.form.sort_popup_value != 'ASC') {
      //     newLink = link.replace('ASC', 'DESC');
      //   } else if (!isASCSortMethod && this.form.sort_popup_value != 'DESC') {
      //     newLink = link.replace('DESC', 'ASC');
      //   }

      //   if (newLink.length) {
      //     localStorage.setItem('AttachmentLink', newLink);
      //   }
      // }
      //при применении сортировки со страниц прикрепления
      //кешируем значения
      if (this.mode === 'Attach' || this.mode === 'massAttach') {
        store.commit('filters/setSortValues', {
          moduleName: this.mode,
          values: {
            sort_popup_sort: this.form['sort_popup_sort'],
            sort_popup_value: this.form['sort_popup_value']
          }
        });
      }

      await store.dispatch('common/applyFilters', {
        module: this.moduleName,
        intents: request,
        filters:
          this.moduleName != 'vacancy_candidates'
            ? this.formFilterValues
            : {
                ...this.formFilterValues,
                hidden_stage_ids: store.state.rightPanel.hiddenStages
              },
        orderBy: this.form['sort_popup_sort'],
        sortOrder: this.form['sort_popup_value'],
        isAttachment: Boolean(massAttachment)
      });

      this.closeDialog();
    }
  },
  computed: {
    formFilterValues() {
      let filters = store.state.filters.filtersActive
        ? {
            ...store.state.filters.filterConfig.filters,
            ...store.state.filters.filterConfig.custom_filters
          }
        : {};
      let filterValues = {};
      Object.keys(filters).forEach(filter => {
        filterValues[filter] = filters[filter].value;
      });
      return filterValues;
    },
    popupWidth() {
      return DIALOG_WIDTH[store.state.filters?.intents.size] || DIALOG_WIDTH.S;
    },
    noChanges() {
      return JSON.stringify(this.originalSort) === JSON.stringify(this.form);
    },
    filters() {
      return store.state.filters?.sortPopupMetaData?.panels?.length
        ? store.state.filters?.sortPopupMetaData?.panels[0]?.rows
        : {};
    },
    buttons() {
      return store.state.filters?.sortPopupMetaData?.bottom_butons || {};
    },
    currentPageSortCashValues() {
      return store.state.filters.sortValues[this.mode] || null;
    }
  },
  components: {
    'el-dialog': Dialog,
    'el-form': Form,
    'el-form-item': FormItem,
    Button,
    Dropdown
  }
};
</script>

<style lang="scss" scoped>
.dialog {
  ::v-deep .el-dialog {
    max-width: inherit !important;
    height: auto !important;

    & > .el-dialog__body {
      padding: 16px 24px !important;
    }
  }

  .filter:not(:last-child) {
    margin-bottom: 8px !important;
  }

  ::v-deep .el-form-item__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    p {
      font-size: 14px;
      line-height: 24px;
      color: $grey80;
    }
  }
}
</style>
